export const SHELF_DIVIDER = 'divider'
export const SHELF_POS = 'pos'
